<template>
  <div id="selfStudy_list">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <div class="screen">
      <div class="screenBox">
        <a
          v-for="(item, index) in typeList"
          :key="item.Id"
          :class="{ side: bqflNumber == item.Id }"
          @click="bqfl(item, 'bqflNumber')"
          >{{ item.Name }}<span>单项练习</span></a
        >
      </div>
      <div class="clearfix screen_2" :class="{ up: screenup }">
        <div class="screen_left_2">
          <p>
            <strong>套题类型：</strong>
            <span>
              <a
                :class="{ side: kmNum == -2 }"
                @click="
                  bqfl(
                    {
                      Id: -2,
                      Name: '不限',
                      Type: 2,
                    },
                    'kmNum'
                  )
                "
                >不限</a
              ></span
            >
            <span class="inline_tag">
              <a
                :class="{ side: kmNum == item.Id }"
                @click="bqfl(item, 'kmNum')"
                v-for="item in pulloverList"
                :key="item.Id"
                >{{ item.Name }}</a
              >
              <a
                :class="{ side: kmNum == -1 }"
                @click="bqfl({ Id: -1, Name: '其他', Type: 2 }, 'kmNum')"
                >其他</a
              >
            </span>
          </p>
          <p>
            <strong>专项分类：</strong>
            <span>
              <a
                :class="{ side: kcflNum == item.Id }"
                @click="bqfl(item, 'kcflNum')"
                v-for="item in specialList"
                :key="item.Id"
                >{{ item.Name }}</a
              >
            </span>
          </p>
        </div>

        <!-- 搜索 -->
        <div class="search">
          <input
            type="text"
            ref="ipt"
            placeholder="搜索"
            v-model="searchValue"
            @keyup.enter="searchEnter"
            @focus="searchfocus(1)"
            @blur="searchblur(2)"
          />
        </div>
      </div>
    </div>
    <div class="main_box">
      <!-- screen end -->
      <div
        class="other_main"
        v-if="
          bqflNumber == 4 &&
          dataList.length &&
          ($store.state.userInfo.Type == 2 ||
            ($store.state.userInfo.VipList &&
              $store.state.userInfo.VipList.some(
                (item1) => item1.VipType == 1
              ))) &&
          kcflNum == 76
        "
      >
        <a
          ref="a_jump1"
          @click="toNavRandom"
          class="other_item"
          target="_blank"
        >
          <div class="left">
            <div class="name_box">
              <div class="name text__overflow">GRE-数学 Alpha Section</div>
              <div class="desc text__overflow">
                随机生成一个Section 包含10道相关试题
              </div>
            </div>
          </div>
          <div class="right">
            <div class="questions_count">
              <div class="gray">题量</div>
              <div>共10题</div>
            </div>
            <div class="answer_box">
              <div class="gray">答卷情况</div>
              <div>练{{ greCount }}次</div>
            </div>
          </div>
          <div style="clear: both"></div>
        </a>
      </div>
      <div class="other_main" v-show="kcflNum != -1" v-loading="loading2">
        <div
          class="childList"
          v-for="(item0, index0) in dataListTitle"
          :key="index0"
          v-if="item0.childList.length > 0"
        >
          <div class="title">
            {{ item0.Title }}
          </div>
          <div class="childList clearfix">
            <a
              ref="a_jump1"
              class="other_item"
              v-for="(item, index) in item0.childList"
              :key="item.Id"
              target="_blank"
            >
              <div class="answer_box">
                <div
                  v-if="item.AnswerSectionId"
                  class="score_div"
                  @click.stop="todetail(item, 99)"
                >
                  上次结果
                </div>
                <div v-else>未作答</div>
              </div>
              <el-tooltip
                :content="'· ' + item.Title"
                placement="top"
                effect="light"
              >
                <div class="name_box of1">
                  {{ "· " + item.Title }}
                </div>
              </el-tooltip>
              <div class="questions_count" v-if="!item.Unfinished">
                <div>题量：</div>
                <div class="gray">共{{ item.QuestionCount }}题</div>
              </div>
              <div
                v-if="
                  item.Unfinished &&
                    item.QuestionCount - 0 > 1 &&
                    [8, 28].indexOf(item.SubjectType) == -1
                "
                class="df_view"
              >
                <div class="btn_status btn_status_1" @click="todetail(item, 3)">
                  继续答题
                </div>
                <div class="btn_status btn_status_2" @click="todetail(item, 1)">
                  重新答题
                </div>
              </div>
              <div class="btn_status_3" v-else @click="todetail(item, 2)">
                <img src="../../assets/practiceSystem/icon01.png" />
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="pagination_footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="limit"
          :total="total"
          background
          layout="total,prev, pager, next, jumper,->"
        >
        </el-pagination>
      </div>
    </div>
    <cdkey-modal ref="CDKModal">
      <template #modalMIddle>
        <div class="cdk_modal_main">
          <img
            src="@/assets/practiceSystem/modal_close.png"
            class="modal_close_icon"
            alt=""
            @click="modalClose"
          />
          <img
            src="@/assets/practiceSystem/cdk_modal_img.png"
            class="modal_img"
            alt=""
          />
          <div class="tips_modal">请联系您的留学/考培顾问，获取试卷兑换码</div>
          <div class="btn_modal" @click="modalClose">确定</div>
        </div>
      </template>
    </cdkey-modal>
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部
import cdkeyModal from "@/components/modal/cdkeyModal";
import banner from "../../page2/banner/banner.vue"; //头部banner图
import { getRandom } from "@/common/utils";
import { setEncryption } from "@/api/common";
export default {
  name: "practiceSystemList",
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header,
    cdkeyModal,
    banner,
  },
  data() {
    return {
      pageTypeId: 37,
      screenup: false,
      typeList: [], //课程分类数据
      specialList: [], //专项分类数据
      pulloverList: [], //套题数据
      themeList: [], //题材数据
      difficultyList: [], //难度数据
      bqflNumber: "",
      kcflNum: "",
      kmNum: "",
      tiCai: "",
      nanDu: "",
      pxID: 1,
      total: 0,
      searchValue: "",
      tokenkey: "",
      currentPage: 1, // 当前页码
      limit: 4, //每页条数,
      limit2: 100, //每页条数,
      dataList: [],
      dataListTitle: [],
      greCount: 0,
      loading2: false,
      isTestPaper: true,
    };
  },
  computed: {
    isTiCai() {
      return this.kcflNum != -1;
    },
    isNanDU() {
      return this.kcflNum != -1;
    },
  },
  async created() {
    let that = this;
    this.tokenkey = this.$cookies.get("token");
    this.getGREMathNumber();
    await this.getKPTestsModelType("", "", "DifficultyType", 4);
    this.getKPTestsModelType();

    if (that.$route.query.type) {
      setTimeout(() => {
        var query = that.$route.query.type;
        let typeId = that.typeList.findIndex((x) => x.Name == query);
        console.log(query, typeId, "typeId");
        that.bqfl(that.typeList[typeId], "bqflNumber");
      }, 500);
    }
  },
  methods: {
    modalClose() {
      this.$refs.CDKModal.close();
    },
    judgeIsAnswer() {
      let flag = false;
      if (this.$store.state.userInfo.Type == 2) {
        flag = true;
      } else if (
        this.$store.state.userInfo.VipList &&
        this.$store.state.userInfo.VipList.some((item1) => item1.VipType == 1)
      ) {
        flag = true;
      }
      return flag;
    },
    iconShrink() {
      this.screenup = true;
    },
    iconOpen() {
      this.screenup = false;
    },
    getMoKaoList(url = "") {
      let that = this;
      this.dataListTitle = [];
      let baseUrl =
        "https://schoolapi.eiceducation.com.cn/api/KPTestsTestPaper";
      let ids = "";
      // if (this.$store.state.userInfo.Type == 2) {
      //   baseUrl = "https://schoolapi.eiceducation.com.cn/api/KPTestsTestPaper";
      // } else if (
      //   this.$store.state.userInfo.VipList &&
      //   this.$store.state.userInfo.VipList.some(item1 => item1.VipType == 1)
      // ) {
      //   baseUrl = "https://schoolapi.eiceducation.com.cn/api/KPTestsTestPaper";
      //   ids = this.$store.state.userInfo.VipList.reduce(
      //     (prev, cur, index, arr) => {
      //       return prev + (cur.ContentIds ? cur.ContentIds + "," : "");
      //     },
      //     ""
      //   );
      // }
      if (this.kmNum != -1) {
        this.limit = 4;
      }
      this.$http
        .get(
          `${baseUrl}?${url}&order=${this.pxID}&page=${this.currentPage}&limit=${this.limit}`,
          {
            headers: {
              "content-type": "application/json; charset=utf-8",
              token: this.tokenkey,
            },
          }
        )
        .then((res) => {
          if (res.data.succ) {
            let { results, count } = res.data;
            console.log(this.dataListTitle, "this.dataListTitle");
            if (this.kmNum == -1) {
              this.dataListTitle = [
                {
                  Title: "其他",
                  childList: [],
                },
              ];
              this.isTestPaper = false;
              this.limit2 = 12;
              this.getOtherList(url, "", 0);
              return;
            } else {
              this.isTestPaper = true;
              this.limit2 = 100;
              this.total = count;
            }
            this.dataListTitle = results;
            this.dataListTitle.forEach((item, index) => {
              item.sortIndex = index + 1;
              item.childList = [];
              this.getOtherList(url, item.Id, index);
            });
          }
        });
    },
    // 其他列表
    getOtherList(url = "", testPaperId, idx) {
      this.loading2 = true;
      console.log("this.isVip ", this.$store.state.userInfo);
      let vipTestPaperIds = "";
      let baseUrl = "https://schoolapi.eiceducation.com.cn/api/KPTestsSection";
      // if (this.$store.state.userInfo.Type == 2) {
      //   baseUrl = "https://schoolapi.eiceducation.com.cn/api/KPTestsSection";
      // } else if (
      //   this.$store.state.userInfo.VipList &&
      //   this.$store.state.userInfo.VipList.some(item1 => item1.VipType == 1)
      // ) {
      //   baseUrl = "https://schoolapi.eiceducation.com.cn/api/KPTestsSection";
      //   vipTestPaperIds = this.$store.state.userInfo.VipList.reduce(
      //     (prev, cur, index, arr) => {
      //       return prev + (cur.ContentIds ? cur.ContentIds + "," : "");
      //     },
      //     ""
      //   );
      // }
      this.$http
        .get(
          `${baseUrl}?${url}&order=${this.pxID}&page=${this.currentPage}&limit=${this.limit2}&testPaperId=${testPaperId}&isTestPaper=${this.isTestPaper}`,
          {
            headers: {
              "content-type": "application/json; charset=utf-8",
              token: this.tokenkey,
            },
          }
        )
        .then((res) => {
          if (res.data.succ) {
            let { results, count } = res.data;
            if (this.kmNum == -1) {
              this.total = count;
            }
            if (this.kmNum == -1) {
              this.limit = this.limit2;
            }
            this.dataListTitle[idx].childList = [];
            this.dataListTitle[idx].childList = results;
            this.dataListTitle[idx].childList.forEach((item, index) => {
              item.sortIndex = index + 1;
            });
            this.$forceUpdate();
            this.loading2 = false;
          }
        });
    },
    //枚举类型
    async getKPTestsModelType(
      pId = "",
      type = "",
      code = "CourseType",
      all = 1
    ) {
      await this.$http
        .get(
          `https://schoolapi.eiceducation.com.cn/api/KPTestsModelType?pId=${pId}&type=${type}&code=${code}`
        )
        .then((res) => {
          if (res.data.succ) {
            let { results } = res.data;
            // if(code=="CourseType"){
            //   results = results.filter(item => item.Id != 3);
            // }
            if (results.length) {
              switch (all) {
                case 1:
                  this.bqflNumber = results[0].Id;
                  this.typeList = results;
                  if (this.typeList.length) {
                    this.getKPTestsModelType(results[0].Id, "", "", 2);
                  }
                  break;
                case 2:
                  this.specialList = results.filter((item) => item.Type == 1);
                  if (this.specialList.length) {
                    this.kcflNum = this.specialList[0].Id;
                  }
                  this.pulloverList = results.filter((item) => item.Type == 2);
                  console.log(this.pulloverList, "this.pulloverList");
                  this.kmNum = -2;
                  this.getList();
                  console.log(results, "results");
                  if (this.typeList.length) {
                    this.getKPTestsModelType(results[2].Id, "", "", 3);
                  }
                  break;
                case 3:
                  this.themeList = results;
                  this.tiCai = -3;
                  break;
                case 4:
                  this.difficultyList = results;
                  this.nanDu = -4;
                  break;
              }
            }
          }
        })
        .catch(function () {
          // console.log('错误');
        });
    },
    filterUrl(url) {
      let { bqflNumber, searchValue, kcflNum, kmNum, tiCai, nanDu } = this;
      if (String(bqflNumber)) {
        url += `courseType=${bqflNumber}`;
      }
      searchValue = $.trim(searchValue);
      if (searchValue) {
        url += `&keyword=${searchValue}`;
      }
      if (String(kmNum) && kmNum != -2 && kmNum != -1) {
        url += `&setQuestionType=${kmNum}`;
      }
      if (kcflNum != -1 && String(kcflNum)) {
        url += `&subjectType=${kcflNum}`;
      }
      if (kcflNum != -1 && tiCai != -3 && String(tiCai)) {
        url += `&themeType=${tiCai}`;
      }
      if (kcflNum != -1 && nanDu != -4 && String(nanDu)) {
        url += `&difficultyType=${nanDu}`;
      }
      return url;
    },
    getList(isRestPage = true) {
      if (isRestPage) {
        this.currentPage = 1;
      }
      let url = "";
      url = this.filterUrl(url);
      // if (this.kcflNum == -1) {
      //   this.getMoKaoList(url);
      // } else {
      this.getMoKaoList(url);
      // }
    },
    getGREMathNumber() {
      let baseUrl = "https://schoolapi.eiceducation.com.cn/api/GREMathNumber";
      this.$http
        .get(`${baseUrl}`, {
          headers: {
            "content-type": "application/json; charset=utf-8",
            token: this.tokenkey,
          },
        })
        .then((res) => {
          if (res.data.succ) {
            let { results } = res.data;
            this.greCount = results;
          }
        });
    },

    //课程
    async bqfl(itemData, type) {
      this[type] = itemData.Id;
      console.log(itemData, type, "itemData, type");
      if (type == "bqflNumber") {
        this.searchValue = "";
        this.currentPage = 1;
        this.getKPTestsModelType(itemData.Id, "", "", 2);
      } else {
        if (type == "kcflNum" && itemData.Id != -1) {
          // await this.getKPTestsModelType(itemData.Id, "", "", 3);
          this.getList();
        } else {
          this.getList();
        }
      }
    },
    //排序方式
    SortMode(e) {
      this.pxID = e;
      this.getList();
    },
    searchfocus(e) {
      this.enter = e;
    },
    searchblur(e) {
      this.enter = e;
    },
    searchEnter() {
      document.onkeydown = (e) => {
        //13表示回车键，baseURI是当前页面的地址，为了更严谨，也可以加别的，可以打印e看一下
        if (e.keyCode === 13 && this.enter == 1) {
          //回车后执行搜索方法
          this.$refs.ipt.blur();
          this.getList();
        }
      };
    },
    searchClick() {
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList(false);
    },
    async todetail(itemData, restart) {
      console.log("itemData", itemData);
      if (this.tokenkey) {
        if (!itemData.IsPublic && !this.judgeIsAnswer()) {
          this.$refs.CDKModal.open();
          return;
        }
        this.$utils.gatAllNavUrl({
          ...itemData,
          paperId: itemData.Id,
          restart,
          a_flag: restart == 99 ? 2 : 1,
          a_type: 2,
          transcript: itemData.AnswerSectionId,
        });
        // let { bqflNumber, kcflNum } = this;
        // console.log(bqflNumber, kcflNum, "kcflNum");
        // // TODO
        // //改域名
        // let baseUrl = this.$utils.getWindowNavUrl(1);
        // let url = "";
        // if (bqflNumber == 3) {
        //   if (String(kcflNum) && kcflNum == -1) {
        //     url = `${baseUrl}/progress?testPaperId=${itemData.Id}&is_clear_storge=1`;
        //   } else if (String(kcflNum) && kcflNum != -1) {
        //     switch (parseInt(kcflNum)) {
        //       case 28: //听力
        //         url = `${baseUrl}/progress?sectionId=${itemData.Id}&subject_type=28&is_clear_storge=1`;
        //         break;
        //       case 27: //阅读
        //         url = `${baseUrl}/progress?sectionId=${itemData.Id}&subject_type=27&is_clear_storge=1`;
        //         break;
        //       case 30: //写作
        //         url = `${baseUrl}/progress?sectionId=${itemData.Id}&subject_type=30&is_clear_storge=1`;
        //         break;
        //       case 29: //口语
        //         url = `${baseUrl}/progress?sectionId=${itemData.Id}&subject_type=29&is_clear_storge=1`;
        //         break;
        //     }
        //   }
        // } else if (bqflNumber == 4) {
        //   baseUrl = this.$utils.getWindowNavUrl(3);
        //   url = `${baseUrl}/progress?id=${itemData.Id}&type=${
        //     kcflNum == -1 ? "test" : "section"
        //   }`;
        // } else if (bqflNumber == 2) {
        //   baseUrl = this.$utils.getWindowNavUrl(2);
        //   url = `${baseUrl}/progress?sectionId=${itemData.Id}&pageMeta=${
        //     kcflNum == -1 ? 1 : itemData.SubjectType
        //   }`;
        // } else if (bqflNumber == 607) {
        //   baseUrl = this.$utils.getWindowNavUrl(4);
        //   url = `${baseUrl}?sectionId=${itemData.Id}&pageMeta=${
        //     kcflNum == -1 ? 1 : itemData.SubjectType
        //   }`;
        // }
        // let tempWindow = window.open("/loading", getRandom(999, 100));
        // let res = await setEncryption({
        //   token: this.$cookies.get("token")
        // });
        // console.log("url", url);
        // url = `${url}&restart=${restart}`;
        // if (res.data.code == 200) {
        //   tempWindow.location.href = `${url}&ep=${
        //     res.data.results
        //   }&timestamp=${getRandom(999, 100)}`;
        // } else {
        //   tempWindow.close();
        // }
      } else {
        // 判断登录弹窗
        return (this.$refs.header.$refs.login.logintc = true);
      }
    },
    // async toResult(itemData) {
    //   if (this.tokenkey) {
    //     let { bqflNumber, kcflNum } = this;
    //     // TODO
    //     //改域名
    //     let baseUrl = this.$utils.getWindowNavUrl(1);
    //     let url = "";
    //     if (bqflNumber == 3) {
    //       if (String(kcflNum) && kcflNum == -1) {
    //         url = `${baseUrl}/toefl/results?testPaperId=${itemData.Id}&transcriptId=${itemData.Transcript}`;
    //       } else if (String(kcflNum) && kcflNum != -1) {
    //         switch (parseInt(kcflNum)) {
    //           case 28: //听力
    //             url = `${baseUrl}/toefl/listening/result?sectionId=${itemData.Id}&transcriptId=${itemData.AnswerSectionId}`;
    //             break;
    //           case 27: //阅读
    //             url = `${baseUrl}/toefl/reading/result?sectionId=${itemData.Id}&transcriptId=${itemData.AnswerSectionId}`;
    //             break;
    //           case 30: //写作
    //             url = `${baseUrl}/toefl/writing/result?sectionId=${itemData.Id}&transcriptId=${itemData.AnswerSectionId}`;
    //             break;
    //           case 29: //口语
    //             url = `${baseUrl}/toefl/speaking/result?sectionId=${itemData.Id}&transcriptId=${itemData.AnswerSectionId}`;
    //             break;
    //         }
    //       }
    //     } else if (bqflNumber == 4) {
    //       baseUrl = this.$utils.getWindowNavUrl(3);
    //       if (String(kcflNum) && kcflNum == -1) {
    //         url = `${baseUrl}/testResult?id=${itemData.Id}&type=test`;
    //       } else if (String(kcflNum) && kcflNum != -1) {
    //         url = `${baseUrl}/sectionResult?id=${itemData.Id}&type=section`;
    //       }
    //     } else if (bqflNumber == 2) {
    //       baseUrl = this.$utils.getWindowNavUrl(2);
    //       if (String(kcflNum) && kcflNum == -1) {
    //         url = `${baseUrl}/comprehensive-result?sectionId=${itemData.Id}&pageMeta=1`;
    //       } else if (String(kcflNum) && kcflNum != -1) {
    //         url = `${baseUrl}/result?sectionId=${itemData.Id}&pageMeta=${itemData.SubjectType}`;
    //       }
    //     } else if (bqflNumber == 607) {
    //       baseUrl = this.$utils.getWindowNavUrl(4);
    //       if (String(kcflNum) && kcflNum == -1) {
    //         url = `${baseUrl}/comprehensive-result?sectionId=${itemData.Id}&pageMeta=1&transcriptId=${itemData.Transcript}`;
    //       } else if (String(kcflNum) && kcflNum != -1) {
    //         url = `${baseUrl}/section-result?sectionId=${itemData.Id}&pageMeta=${itemData.SubjectType}&transcriptId=${itemData.AnswerSectionId}`;
    //       }
    //     }
    //     let tempWindow = window.open("/loading", getRandom(999, 100));
    //     let res = await setEncryption({
    //       token: this.$cookies.get("token")
    //     });
    //     if (res.data.code == 200) {
    //       tempWindow.location.href = `${url}&ep=${
    //         res.data.results
    //       }&timestamp=${getRandom(999, 100)}`;
    //     } else {
    //       tempWindow.close();
    //     }
    //   } else {
    //     // 判断登录弹窗
    //     return (this.$refs.header.$refs.login.logintc = true);
    //   }
    // },
    toNavRandom() {
      let tempWindow = window.open("/loading", getRandom(999, 100));
      let baseUrl =
        "https://schoolapi.eiceducation.com.cn/api/KpTestsRandomSection";
      this.$http
        .get(`${baseUrl}`, {
          headers: {
            "content-type": "application/json; charset=utf-8",
            token: this.tokenkey,
          },
        })
        .then(async (res) => {
          if (res.data.succ) {
            let { results } = res.data;
            let baseUrl = this.$utils.getWindowNavUrl(3);
            let url = `${baseUrl}/progress?id=${results}&type=${"section"}`;
            let res1 = await setEncryption({
              token: this.$cookies.get("token"),
            });
            if (res1.data.code == 200) {
              tempWindow.location.href = `${url}&ep=${
                res1.data.results
              }&timestamp=${getRandom(999, 100)}`;
            } else {
              tempWindow.close();
            }
          }
        });
    },
  },
};
</script>
<style scoped lang="less">
.text__overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

.tab_boxs {
  overflow: hidden;
  transition: 0.2s;
  height: 51px;
}

.bottombox {
  box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
  position: relative;
  z-index: 9;
}

.header_left {
  background: #f00;
}

.banner {
  width: 100%;
  height: 452px;
  position: relative;
  overflow: hidden;
}

.banner img {
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -960px;
}

.screen {
  background: #fff;
  padding-top: 30px;
}

.screenBox {
  width: 862px;
  height: 126px;
  margin: 0 auto;
  background: url(../../assets/courselist/searchBj2.png) no-repeat;
  background-size: 1200px 160px;
  margin-bottom: 50px;
  padding-left: 338px;
  padding-top: 34px;
}

.screenBox a {
  display: block;
  width: 141px;
  height: 73px;
  margin-right: 30px;
  background: url(../../assets/courselist/search5.png) left no-repeat;
  background-size: 140px 75px;
  font-weight: 500;
  font-size: 20px;
  color: #333333;
  line-height: 20px;
  padding-top: 27px;
  padding-left: 19px;
  cursor: pointer;
  float: left;
}

.screenBox a span {
  display: block;
  padding-top: 9px;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 12px;
}

.screenBox a:nth-child(1).side {
  background: url(../../assets/courselist/search1_1.png) no-repeat;
  background-size: 150px 100px;
  color: rgba(135, 141, 255, 1);
}

.screenBox a:nth-child(2).side {
  background: url(../../assets/courselist/search2_1.png) no-repeat;
  background-size: 150px 100px;
  color: rgba(135, 141, 255, 1);
}

.screenBox a:nth-child(3).side {
  background: url(../../assets/courselist/search3_1.png) no-repeat;
  background-size: 150px 100px;
  color: rgba(135, 141, 255, 1);
}

.screenBox a:nth-child(4).side {
  background: url(../../assets/courselist/search4_1.png) no-repeat;
  background-size: 150px 100px;
  color: rgba(135, 141, 255, 1);
}

.screenBox a:nth-child(1).side span {
  color: rgba(135, 141, 255, 1);
}

.screenBox a:nth-child(2).side span {
  color: rgba(135, 141, 255, 1);
}

.screenBox a:nth-child(3).side span {
  color: rgba(135, 141, 255, 1);
}

.screenBox a:nth-child(4).side span {
  color: rgba(135, 141, 255, 1);
}

.screen_2 {
  width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  .screen_left_2 {
    width: calc(100% - 250px);
  }
}

.screen_2 p {
  text-align: left;
  display: table;
  height: 28px;
  margin-bottom: 28px;
}

.screen_2 p strong {
  display: inline-block;
  width: 100px;
  font-weight: 400;
  font-size: 20px;
  color: #666666;
  line-height: 28px;
  float: left;
}

.screen_2 p span {
  display: inline-block;
  /* width: 1080px; */
  float: left;
  cursor: pointer;
}

.screen_2 p a {
  display: inline-block;
  min-width: 75px;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  line-height: 28px;
  border-radius: 14px;
  text-align: left;
  cursor: pointer;
  padding: 0 20px;
  box-sizing: border-box;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.screen_2 p a:hover {
  color: rgba(51, 124, 255, 1);
  cursor: pointer;
}

.screen_2 p a.side {
  background: rgba(51, 124, 255, 0.05);
  color: rgba(51, 124, 255, 1);
  cursor: pointer;
}

.main_box {
  background-color: #ffffff;
}

.main,
.other_main {
  width: 1200px;
  margin: 0 auto;
  min-height: 300px;
}

.other_main .title {
  width: 1138px;
  height: 60px;
  border-radius: 0px 0px 0px 0px;
  font-weight: 500;
  font-size: 20px;
  color: #333333;
  line-height: 60px;
  text-align: left;
  padding-left: 62px;
  background: url(../../assets/practiceSystem/title.png) 10px no-repeat #fbfbfb;
  background-size: 42px 42px;
  margin-bottom: 30px;
}

.other_item {
  display: block;
  margin-right: 20px;
  margin-bottom: 30px;
  background-color: #fff;
  width: 285px;
  height: 150px;
  background: url(../../assets/practiceSystem/bj.png) no-repeat;
  background-size: 285px 150px;
  box-sizing: border-box;
  float: left;
  position: relative;
}

.other_item:nth-child(4n) {
  margin-right: 0;
}

.other_item .answer_box {
  position: absolute;
  top: 0;
  left: 0;
  width: 82px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}

.other_item .answer_box .score_div {
  color: #337cff;
  text-decoration: underline;
}

.other_item .name_box {
  position: absolute;
  top: 51px;
  left: 20px;
  width: 245px;
  height: 30px;
  background: #878dff;
  border-radius: 16px 16px 16px 16px;
  font-weight: 500;
  font-size: 20px;
  color: #ffffff;
  line-height: 30px;
  text-align: left;
  text-indent: 10px;
}

.other_item .questions_count {
  position: absolute;
  top: 116px;
  left: 20px;
  display: flex;
  color: #333333;
}

.gray {
  color: #999999;
}

.other_item .btn_status_3 {
  position: absolute;
  top: 98px;
  left: 223px;
  width: 42px;
  height: 42px;
  cursor: pointer;
}

.other_item .btn_status_3 img {
  display: block;
  width: 42px;
  height: 42px;
}

.other_item .df_view {
  position: absolute;
  top: 104px;
  left: 75px;
  display: flex;
}

.other_item .df_view .btn_status {
  width: 90px;
  height: 32px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 32px;
  text-indent: 27px;
  cursor: pointer;
}

.other_item .df_view .btn_status_1 {
  border-radius: 16px 16px 16px 16px;
  background: url(../../assets/practiceSystem/icon02.png) 3px #15ceb2 no-repeat;
  background-size: 24px 24px;
  margin-right: 10px;
}

.other_item .df_view .btn_status_2 {
  border-radius: 16px 16px 16px 16px;
  background: url(../../assets/practiceSystem/icon03.png) 3px #337cff no-repeat;
  background-size: 24px 24px;
}

.pagination_footer {
  padding: 31px 0 52px 0;
  width: 1180px;
  text-align: right;
  margin: 0 auto;
}

.inline_tag {
  // width: 995px !important;
}

.inline_tag a {
  margin-bottom: 10px;
}

.score_div {
  cursor: pointer;
  text-decoration: underline;
}

.progress_cirle {
  width: 52px;
  height: 55px;
}
.search {
  width: 200px;
  height: 42px;
  background: #ffffff;
}

.search input {
  box-sizing: border-box;
  width: 100%;
  height: 42px;
  background: #ffffff;
  border-radius: 21px;
  border: 1px solid #dddddd;
  padding-left: 20px;
  background: url(../../assets/index/search.png) 16px no-repeat;
  background-size: 24px 24px;
  padding-left: 48px;
  font-size: 16px;
}
.cdk_modal_main {
  width: 800px;
  position: relative;
  text-align: center;
  .modal_close_icon {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 37px;
    height: 37px;
    cursor: pointer;
  }
  .modal_img {
    width: 375px;
    height: 330px;
  }
  .tips_modal {
    font-size: 24px;
    color: #333333;
    margin: 20px 0 40px;
  }
  .btn_modal {
    cursor: pointer;
    width: 160px;
    height: 42px;
    line-height: 42px;
    background: #ff0659;
    border-radius: 21px 21px 21px 21px;
    font-size: 20px;
    color: #ffffff;
    text-align: center;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/page2/practiceSystem/list2.vue